// extracted by mini-css-extract-plugin
export default {"Modal":"styles_Modal__DHFWC","Modal__contactStyle":"styles_Modal__contactStyle__Hn-1e"};